<template>
  <!--
    	作者：luoyiming
    	时间：2019-10-26
    	描述：门店-店员列表-添加店员
    -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="200px">
      <!--添加店员-->
      <div class="common-form">添加酒店</div>
      <el-form-item
        label="酒店名称"
        :rules="[{ required: true, message: ' ' }]"
      >
        <el-input
          class="max-w460"
          v-model="form.name"
          placeholder="请输入酒店名称"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="账号/手机号"
        :rules="[{ required: true, message: ' ' }]"
      >
        <el-input
          class="max-w460"
          v-model="form.mobile"
          placeholder="请输入账号/手机号"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="登录密码"
        :rules="[{ required: true, message: ' ' }]"
      >
        <el-input
          v-model="form.password"
          placeholder="请输入登录密码"
          type="password"
          class="max-w460"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="确认密码"
        :rules="[{ required: true, message: ' ' }]"
      >
        <el-input
          v-model="form.password1"
          placeholder="请输入确认密码"
          type="password"
          class="max-w460"
        ></el-input>
      </el-form-item>
      <div>温馨提示：密码不传默认不修改</div>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button
          size="small"
          type="primary"
          @click="onSubmit"
          
          >提交</el-button
        >
      </div>
    </el-form>
  </div>
</template>

<script>
import SupplierApi from "@/api/supplier.js";
import Upload from "@/components/file/Upload";
import GetUser from "@/components/user/GetUser.vue";
export default {
  components: {
    /*上传组件*/
    Upload,
    /*选择用户*/
    GetUser,
  },
  data() {
    return {
      /*form表单数据*/
      form: {
       name:'',
       mobile:'',
       password:'',
       password1:''
      },
     
    };
  },
  created() {
    /*获取列表*/
    this.form.id =this.$route.query.id;
    this.getdata();
  },
  methods: {
    /*获取广告类别*/
    getdata() {
      let self = this;
      let Params = {
        id:this.form.id
      };

      SupplierApi.hoteldetail(Params, true)
        .then((res) => {
          console.log(res.data)
          self.form=res.data
          // self.category = res.data.category;
          // self.data = res.data.data;
          // if (self.category.length > 0) {
          //   self.form.categoryId = self.category[0].categoryId;
          // }
        })
        .catch((error) => {});
    },
    onSubmit() {
      let self = this;
      let form = self.form;
      console.log(form)
      // if (form.name == '') {
      //           self.$message({
      //             message: "请输入酒店名称",
      //             type: "error",
      //           });
      //           return false
      // }
      // if (form.mobile == '') {
      //           self.$message({
      //             message: "请输入账号/手机号",
      //             type: "error",
      //           });
      //           return false
      // }
      // if (form.password == '') {
      //           self.$message({
      //             message: "请输入密码",
      //             type: "error",
      //           });
      //           return false
      // }
      // if (form.password1 != form.password) {
      //           self.$message({
      //             message: "密码不一致",
      //             type: "error",
      //           });
      //           return false
      // }
      SupplierApi.hoteledit(form, true)
            .then((data) => {
              // self.loading = false;
              if (data.code == 1) {
                self.$message({
                  message: "恭喜你，酒店添加成功",
                  type: "success",
                });
                self.$router.push("/supplier/hotelmanagement/index");
              } else {
                self.loading = false;
              }
            })
            .catch((error) => {
              self.loading = false;
            });
      // self.$refs.form.validate((valid) => {
      //   if (valid) {
      //     self.loading = true;
      //    
      //   }
      // });
    },

    /*上传*/
    // openUpload(e) {
    //   this.type = e;
    //   this.isupload = true;
    // },

    /*获取图片*/
    returnImgsFunc(e) {
      if (e != null && e.length > 0) {
        if (this.type == "logo") {
          this.logo_filePath = e[0].filePath;
          this.form.supplier.logo_id = e[0].fileId;
        } else if (this.type == "business") {
          this.business_filePath = e[0].filePath;
          this.form.supplier.business_id = e[0].fileId;
        }
      }
      this.isupload = false;
    },

    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    },
    /*打开弹出层*/
    userClick() {
      this.open_user = true;
    },

    /*关闭获取用户弹窗*/
    closeDialogFunc(e) {
      if (e.type != "error") {
        this.user_info = e.params[0];
        this.form.supplier.user_id = e.params[0].user_id;
      }
      this.open_user = false;
    },
  },
};
</script>

<style lang="scss" scoped>


.product-add {
  padding-bottom: 50px;
}

.img {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/supplier/hotelmanagement/edit.vue